import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { Ring_circle } from "../../helper/imageConstant";

const Disclaimer = () => {
  return (
    <>
      <ImageSection name={"Disclaimer"} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-4">
              <h1 className="text-[#222222] text-base lg:text-base 3xl:text-lg font-normal">
                By using Vikasfashion.com, the user unconditionally accepts the
                terms and conditions of use as given here under :{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-sm lg:text-base 3xl:text-lg font-normal leading-[26px] space-y-4">
                <li>
                  Before jumping to any conclusions or placing an order, the
                  user may carefully read products information and services
                  displayed in relevant sections and information in frequently
                  asked questions.
                </li>
                <li>
                  The information contained in this website is for general
                  information purposes only. They do not constitute advice and
                  should not be relied upon in making any decision.
                </li>
                <li>
                  Vikasfashion.com is not responsible for the contents of any
                  linked sites. We do not endorse the companies or products to
                  which it links. Your access to any of these third party sites
                  is done entirely at your own risk.
                </li>
                <li>
                  The details of the products or product specifications (for
                  instance weight, color, handwork details, size, etc.) quoted
                  with the product displays are only fairly accurate values.
                  Since most of the products have intricate handwork, there may
                  be slight variation in the pictures displayed and the
                  respective actual products.
                </li>
                <li>
                  Vikasfashion.com will not be liable for any loss of data,
                  loss/profits or any damages under any circumstances what so
                  ever including any circumlocutory, special, subsidiary,
                  indirect, consequential or other damages that result from the
                  use of or inability to use the products/services offered at
                  Vikasfashion.com. In no occurrence/event shall
                  Vikasfashion.com be accountable to the user for any damages,
                  losses, negligence or any actions otherwise, beyond the amount
                  paid by the user to Vikasfashion.com for any specific product
                  or service.
                </li>
                <li>
                  With a view to provide our users/customers latest information
                  and material, Vikasfashion.com will make changes in the
                  products or services described on this site from time to time.
                  The prices displayed on website are for Internet orders.
                  Availability and prices of items are cause to undergo change
                  without prior notice. Any prices displayed on Vikasfashion.com
                  may not be indicative of the actual selling prices in any
                  particular area. We at reserve the right to limit sales,
                  including the right to prohibit sales to re-sellers.
                  Vikasfashion.com is not responsible for any typographical or
                  photographic errors/shortcomings.
                </li>
                <li>
                  Apart from any or all of the aforesaid terms, conditions &
                  disclaimers, any refund or payment by Vikasfashion.com to the
                  user (or anybody acting on his behalf for any reason
                  whatsoever) shall not become a waiver of any or all of the
                  terms and conditions made and shall not become a precedent for
                  similar actions/claims in future or confer any rights on the
                  applicant. All such refunds or payments, if any when made,
                  shall be subjected to a deduction of $25 on account of Bank
                  charges and other processing overheads.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Disclaimer;
